var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/resources/logo.png"}})])])
}]

export { render, staticRenderFns }